<template>
  <div id="LoginLayout" class="font-size-16">
    <div class="header-area">
      <b-container fluid class="px-sm-5">
        <b-row>
          <b-col>
            <img :src="logoSvg" class="img-fluid" style="width: 260px" />
          </b-col>
          <b-col align-self="center" class="text-end">
            <a href="https://envisionit.ai" target="_blank" class="btn btn-outline-light btn-box-shadow">Main site</a>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="banner-area min-vh-100 bg-covid">
      <router-view/>
    </div>
    <div class="footer-right">&copy; 2026 Copyright Envisionit Deep AI. All rights reserved.</div>
    <div class="footer-left">Version 1.5.0.1</div>
  </div>
</template>

<script>
import logoSvg from '@/assets/images/edai-logo.svg'

export default {
  data() {
    return {
      logoSvg
    }
  }
}
</script>
